import { mapMutations } from 'vuex'

export const pageOn = {
    watch: {
        pageOn ( pageOn ) {
            if ( !pageOn ) {
                this.popPage(this.$options.name)
            }
        }
    },
    mounted () {
        setTimeout(() => this.pageOn = true,10)
        //var width = parseInt(getComputedStyle(this.$el.querySelector('.page-content')).width);
        //console.log('this.$el.querySelector(.div-btns)',this.$el.querySelector('.div-btns'))
        //console.log('*** pageOn *** page, width, width / 414',this.$options.name,width,width / 414)
        //this.$el.querySelector('.div-btns') && width > 0 && ( this.$el.querySelector('.div-btns').style.transform = 'scale('+( width / 414 )+')' );
    },
    data () {
        return {
            pageOn: false,
        }
    },
    methods: {
        ...mapMutations(['popPage'])
    }
}